/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/
(function(){
	'use strict';

	// Load event function ... most custom stuff goes here. Safer for async.
	jQuery( window ).on( 'load', function() {

		// Homepage scroll functionality
		jQuery( '#scroll-down' ).click( function( e ) {
			e.preventDefault();
			jQuery( [document.documentElement, document.body] ).animate({
				scrollTop: $("#next-section").offset().top
			}, 1000);
		});


		var windowSize = jQuery(window).width();
		// SEARCH FUNCTIONALITY
		var searchForm = jQuery( '#search-form' );
		var searchInput = jQuery( '#search-input' );

		function navStuff () {
			var windowSize = jQuery(window).width();
			// SEARCH FUNCTIONALITY
			var searchForm = jQuery( '#search-form' );
			var searchInput = jQuery( '#search-input' );

			// This snippet sets the placeholder text dependent on window width
			if (windowSize < 881 ) {
				jQuery('.search-form .form-wrapper form input').attr("placeholder", "Search...");
			} else if (windowSize >= 881) {
				jQuery('.search-form .form-wrapper form input').attr("placeholder", "What can we help you find?");
			}

			// ADDS CLASS TO NAV MENU TO ADJUST BREAK POINTS TO FIT EXTRA MENU ITEMS
			var windowSize = jQuery(window).width();
			if (windowSize < 882 ) {
				jQuery('.site-header__menu').addClass('mobileSearch');
				jQuery('#search-form').addClass('mobile-search');
			} else if ( windowSize >= 882 ) {
				jQuery('.site-header__menu, .menu-toggle').removeClass('mobileSearch open');
				jQuery('#search-form').removeClass('mobile-search');
				jQuery('.site-header__menu').addClass('desktop');
			}

			if ( windowSize < 882 ){
				// This is mobile menu functionality. Used for moving through 1st, 2nd, and third level menus
				jQuery('.site-header').on('click', '.toplevel > button.advance-menu, .toplevel > a', function(event){
					if (jQuery(window).width() < 882 ) {
						jQuery(this).parent().addClass('selected');
						jQuery('.toplevel:not(.selected)').addClass('slideLeft');
						jQuery(this).parent().append("<span class='backButton'>Menu</span>");
						jQuery('.main-menu').addClass('menu-to-lvl-1');
					}
				});
				jQuery('.site-header').on('click', '.toplevel > ul > li > button.advance-menu, .toplevel > ul > li > a', function(event){
					if (jQuery(window).width() < 882 ) {
						jQuery('.main-menu').addClass('menu-to-lvl-2');
					}
				});
				jQuery('.site-header').on('click', '.toplevel > ul > li > ul > li > button.advance-menu, .toplevel > ul > li > ul > li > a', function(event){
					if (jQuery(window).width() < 882 ) {
						jQuery('.main-menu').addClass('menu-to-lvl-3');
					}
				});

				jQuery('.site-header').on('click', '.toplevel .main-menu__submenu > li', function(event){
					if (jQuery(window).width() < 882 ) {
						jQuery(this).addClass('selected');
						var name = jQuery('li.selected').find('.menu-walker-nolink').text();
						jQuery('.toplevel > span:not(.slideLeft)').addClass('slideLeft previousNavParent');
						jQuery('.subitem:not(.selected)').addClass('slideLeft');
						jQuery('.backButton').addClass('backButtonLevelTwo');
						jQuery('.backButtonLevelTwo').text(name);
					}
				});

				jQuery('.site-header').on('click', '.toplevel .main-menu__submenu--l1 > li', function(event){
					if (jQuery(window).width() < 882 ) {
						jQuery(this).addClass('selected');
						jQuery('.subitem:not(.selected)').addClass('slideLeft');
						if (!(backButtonVisible)) {
							jQuery(this).parent().append("<span class='backButton'>Menu</span>");
							backButtonVisible = true;
						}
					}
				});

				jQuery('.site-header').on('click', '.backButton', function(event){
					if (jQuery(window).width() < 882 ) {
						if ( jQuery('.main-menu').hasClass('menu-to-lvl-3') ){
							jQuery('.main-menu').removeClass('menu-to-lvl-3');
							var name = jQuery('.toplevel.selected > a').text();
							jQuery('.backButtonLevelTwo').text(name);

						} else if ( jQuery('.main-menu').hasClass('menu-to-lvl-2') ){
							jQuery('.main-menu').removeClass('menu-to-lvl-2');
							jQuery('.main-menu__item--l1 .subitem').removeClass('selected');
							jQuery('.main-menu .main-menu__item--l1').removeClass('slideLeft').removeClass('selected');
							jQuery('.main-menu__submenu--l2').removeClass('expanded_main-menu__submenu');
							//jQuery('.backButtonLevelTwo').remove();
							jQuery('.rotated_expand-button').removeClass('rotated_expand-button');
							var name = jQuery('.toplevel.selected > a').text();
							jQuery('.backButtonLevelTwo').text('Menu');

						} else if ( jQuery('.main-menu').hasClass('menu-to-lvl-1') ){
							jQuery('.main-menu').removeClass('menu-to-lvl-1');
							jQuery('.main-menu .toplevel').removeClass('slideLeft').removeClass('selected');
							jQuery('.main-menu__submenu--l1').removeClass('expanded_main-menu__submenu');
							jQuery('.backButton').remove();
							jQuery('.rotated_expand-button').removeClass('rotated_expand-button');
						}
					}
				});
			}else{
				jQuery('.main-menu').removeClass('menu-to-lvl-1').removeClass('menu-to-lvl-2').removeClass('menu-to-lvl-3');
				jQuery('.main-menu li, .main-menu ul').removeClass('slideLeft selected expanded_main-menu__submenu');
				jQuery('.main-menu').find('.backButton').remove();
				jQuery('.rotated_expand-button').removeClass('rotated_expand-button');
			}


			// This snippet adds the class to the primary search that is necessary for mobile styling
			jQuery('.menu-toggle').on('click', function(){
				setTimeout(function(){
			 		if (jQuery('.site-header__menu').hasClass('open')) {
						jQuery(searchForm).addClass('mobile-search')
					} else {
						jQuery(searchForm).removeClass('mobile-search')
					}
				}, 300);
			});

			if( jQuery(window).width() < 882 && jQuery('.site-header__menu').hasClass('open') ){
			}else{
				jQuery(searchForm).removeClass('mobile-search');
			}

		}
		navStuff();
		jQuery(window).on('resize', function(event){
			navStuff();
		});

		// This function adds and removes an open class on the main site search
		jQuery('button.search-spyglass').click( function( e ) {
			if (jQuery(searchForm).hasClass('search-form--open')) {
				jQuery(searchForm).removeClass('search-form--open');

			} else {
				jQuery(searchForm).addClass('search-form--open');
				jQuery(searchForm).find('.input-field').focus();
			}
		});

		// This functionality adds an open class on the main site search when on a mobile device.
			// This is distinguished from the above function by only adding the class. Note: removal of this class is provided a click function below
		jQuery('.main-search__field').click( function( e ) {
			jQuery(searchForm).addClass('search-form--open');
			jQuery(searchForm).find('.input-field').focus();
		});

		jQuery('.partial-library-search div .main-search__field').click( function( e ) {
			jQuery(this).closest('.partial-library-search').addClass('search-form--focused');
			jQuery(this).closest('.partial-library-search').find('.input-field').focus();
		});

		// This snippet adds the class to all other search forms for displaying the search options
		jQuery('.library-search__field, .publications-search div input, .site-content .main-search div div input').each(function(e){
			jQuery(this).on('click', function() {
				jQuery(this).closest('form').addClass('search-form--focused');
				jQuery(this).closest('form').find('.input-field').focus();

			})
		});

		// This code snippet makes the primary search bar slide up and away if any area outside of the search element is clicked
		jQuery(document).click(function(event) {
			// Main Site Search
			if (!jQuery(event.target).closest('.search-form, .search-spyglass').length) {
				if( jQuery(this).find('.search-form').hasClass('search-form--open') ){
					jQuery(this).find('.search-form').removeClass( "search-form--open" );
				}
			}
			// Library, Published Research, and 404 page
			if (!jQuery(event.target).closest('form').length) {
				if (jQuery('form').hasClass('search-form--open')) {
					jQuery('form').removeClass( "search-form--open" );
				}
				if (jQuery('form').hasClass('search-form--focused')) {
					jQuery('form').removeClass( "search-form--focused" );
				}
			}

		});

		// This clears the primary search bar's placeholder on click
		jQuery('span.clear-button').click( function( e ) {
			var jQueryinputField = jQuery(searchForm).find('.input-field');
			jQueryinputField.val("");
			jQueryinputField.focus();
		});

		// Targets the placeholder font style
		jQuery('.library-search__field').css('font-style', 'italic');

		jQuery('.library-search__field').keydown(function(event) {
			jQuery(this).css('font-style', 'normal');
		});

		jQuery('.library-search__field').keyup(function(event) {
			if ($(this).val()=="") {
				jQuery(this).css('font-style', 'italic');
			}
		});

		// This adds a class to the optional sub header in layout-page-header
		if ('.sub-header') {
			jQuery('.sub-header').closest('.layout-page-header').addClass('sub-heading');
		}

		// Changes color of breadcrumbs based on if a page as a page header layout. These layouts should be dark.  Thus, we brightnen the breadcrumb color
		if (jQuery('.layout-page-header').length > 0) {
			jQuery('.breadcrumbs').addClass('brighten');
		} else {
			jQuery('.breadcrumbs').removeClass('brighten');
		}

		// forces clones to load images and resize them
		jQuery('.layout-slider').on('click', function(){
			jQuery(window).trigger('resize');
		});


		// Functionality for toggling Equinews Sidebar Widget
		jQuery('.sidebar_container.sidebar .sidebar__posts').children('div:first-of-type').find('ul').css('display', 'block');
		jQuery('.sidebar_container.sidebar .sidebar__posts').children('div:last-of-type').find('ul').css('display', 'none');
		jQuery('.sidebar_container.sidebar div ul').children('li').addClass('linkclicker');

		jQuery('.sidebar_container.sidebar .sidebar__posts .tptn_posts_list_widget h2').addClass('show-popular');
		jQuery('.widget_recent_entries h2').siblings('ul').css('display', 'none');

		jQuery('.sidebar_container.sidebar .sidebar__posts div h2').on('click', function(event){

			if (jQuery(this).closest('div').hasClass('tptn_posts_list_widget')) {
				jQuery(this).addClass('show-popular');
				jQuery(this).siblings('div').find('ul').css('display','block');
				jQuery('.sidebar_container.sidebar h2')
					.not(this)
					.removeClass('show-recent')
					.siblings('ul')
					.css('display','none');
			}

			if (jQuery(this).closest('div').hasClass('widget_recent_entries')) {
				jQuery(this).addClass('show-recent');
				jQuery(this).siblings('ul').css('display','block');
				jQuery('.sidebar_container.sidebar h2')
					.not(this)
					.removeClass('show-popular')
					.siblings('div')
					.find('ul')
					.css('display','none');
			}

		});

		/**
		The following adds a special CSS class to all p tags that only contain img tags and whitespace:
		The trim() function is used with text() to determine if the text only contains whitespace.
		*/
		jQuery('.layout > p, .layout > div p').each(function(i){		  // For each paragraph
			if ( (jQuery(this).find('img').length) &&	 // If there's an image
			(!jQuery.trim(jQuery(this).text()).length))   // and there's no text
			if (!jQuery(this).find('a')) {		// if statement necessary for links included in the cms page header on /tools/clockit
				{
					jQuery(this).find('img').unwrap();		 // remove p tag
				}
			}
		});

		/**
		The following adds a special CSS class to all p tags that only contain iframe tags and whitespace:
		The trim() function is used with text() to determine if the text only contains whitespace.
		*/
		jQuery('.layout > p, .layout > div p').each(function(i){		  // For each paragraph
			if ( (jQuery(this).find('iframe').length) &&	 // If there's an image
			(!jQuery.trim(jQuery(this).text()).length)) {   // and there's no text
				jQuery(this).find('iframe').unwrap();		 // remove p tag
			}
		});

		/*
		The following removes the default bottom margin from a p tag if it is the last child of a div.
		*/
		jQuery('.layout p').each(function(){
			if ($(this).is(':last-child')) {
				$(this).css('margin-bottom', '0em');
			}
		});


		jQuery( ".linkclicker" ).each( function(e) {
			if ( jQuery( this ).find( "a" ).length < 1 ) {
				jQuery(this).removeClass('linkclicker');
			}
		});

		// search child dom elements for a[href], and follow that on click events 2015-11-03
		jQuery( ".linkclicker" ).click( function(e) {
			// If the first link is === last link then override
			if ( jQuery( this ).find( "a:first" ).attr('href') === jQuery( this ).find( "a:last" ).attr('href') ) {
				e.preventDefault();
				if ( jQuery( this ).find( "a:first" ).attr( "target" ) ) {
					// new tab
					window.open( jQuery( this ).find( "a:first" ).attr( "href" ) );
				} else {
					// same tab
					window.location = jQuery( this ).find( "a:first" ).attr( "href" );
				}
			}
		});

		// Media object lists-get bottom border applied and removed on last
		jQuery('.layout-media-object+.layout-media-object+.layout:not(.layout-media-object)').prev('.layout').addClass('media-object-last');

		// 2016-05-15, force opening external links in new tab.
		if ( ! jQuery( 'a' ).attr( 'target' ) ) {
			jQuery( 'a[href^=http]:not([href*="' + dbs.http_host + '"])' ).attr( 'target', '_blank' ).attr( 'rel', 'noopener' );
			jQuery( 'a[href^=http]:not([href*="' + dbs.http_host + '"])' ).append( '<span class="assistive">(opens new window)</span>' ); // Footer Icon duplicates this
		}

		// Functionality for the collapsables acf layout
		jQuery('.layout-collapsables .collapsable_name').each(function() {
			jQuery(this).next('.collapsable_content')
				.removeClass('expand')
				.slideUp();

			jQuery(this).on('click', function() {
				jQuery(this).toggleClass('content-expanded');
				jQuery(this).next('.collapsable_content')
					.toggleClass('expand')
					.slideToggle();
			})
		});


		jQuery('.volume_content__right .chapter').each(function(i){
			jQuery('.chapter_title').on('click', function(i){
				jQuery(this).toggleClass('content-expanded');
				jQuery(this).siblings('ul.sections').toggleClass('expand');
			})
		});

			// Test to load slick slider before executing
			var tryCount = 0;
			var interval = setInterval( function () {

				tryCount++;
				if( $.fn.slick ){
					clearInterval(interval);
					jQuery('.layout-slider').slick({
						prevArrow:"<button class='slick-prev slick-arrow'></button>",
						nextArrow:"<button class='slick-next slick-arrow'></button>",
						dots: true,
						adaptiveHeight: false
					});
					dbs.loadedSlick = true;

					// Slide Counter Functionality

					// Initial appending of the counter
					jQuery('.layout-slider.interior-page-slider').each( function(){
						var totalItems = jQuery(this).find('.slick-slide:not(.slick-cloned)').length;
						var currentIndex = jQuery(this).find('div.slick-current').index();
						jQuery(this).append("<div class='counter'>" + ''+currentIndex+'/'+totalItems+'' + "</div>");
					});

					jQuery('.layout-slider.interior-page-slider').on('afterChange', function(){
						// Removes and reappends the counter when an arrow is clicked
						var totalItems = jQuery(this).find('.slick-slide:not(.slick-cloned)').length;
						jQuery(this).find('.counter').remove();
					   var currentIndex = jQuery(this).find('div.slick-current').index();
					   jQuery(this).append("<div class='counter'>" + ''+currentIndex+'/'+totalItems+'' + "</div>");

					   if (jQuery(this).hasClass('.counter') ) {
						   // Removes and reappends the counter
						   jQuery(this).find('.counter').remove();
						   jQuery(this).append("<div class='counter'>" + ''+currentIndex+'/'+totalItems+'' + "</div>");
					   }
					});

					jQuery('.layout-slider img').onload = function() {

						//REPLACE LAZYLOAD ON CLONED SLICK
						$(".slick-cloned [data-lazy='" + imageSource  + "']").attr("src", imageSource).removeAttr('data-lazy data-srcset data-sizes');
					};
			}
		}, 1000);

		jQuery('.gform_body select').parent().addClass('select-parent');
	
	}); // end onload

	// Enable default resize to parent function
	jQuery('.interior-page-slider .flex-slide__image').addClass('resize-parent');
	//Also in slider re-call in dbs-global-vars
	jQuery('.interior-page-slider .flex-slide__image img').resizeToParent({parent: '.layout .flex-slide__image.resize-parent'});
	jQuery('.three-column--homepage .three-column__column').addClass('resize-parent');
	jQuery('.three-column--homepage .three-column__column .image img').resizeToParent({parent: '.three-column__column.resize-parent'});
	jQuery('.latest_equinews_post + .post .post-image, .latest_equinews_post + .post + .post .post-image').addClass('resize-parent');
	jQuery('.resize-parent > img').resizeToParent({parent: '.resize-parent'});

	var region = dbs.read_cookie ( 'ker_active_region' );

	// Make sure we have a valid cookie
	if ( ! region || region == null || region.length !== 2 ) {
		region = 'us';
		dbs.set_cookie( 'ker_active_region', region, 30 );
	}

	// KER set country / region switcher.
	// set dropdown to match cookie value, must run before the change event
	jQuery( "#region-switcher" ).val( region ).trigger( 'change' );

	// handle user changes region switching menu
	jQuery( "#region-switcher" ).on( 'change', function() {
		if ( dbs.debug === true ) console.log( 'Menu switcher changed' );
		var region = jQuery( '#region-switcher' ).val(),
			partner = dbs.read_cookie ( 'partner' );
		dbs.set_cookie( 'ker_active_region', region, 30 ); // 30 days
		dbs.load_menus( 'click' );
		if ( dbs.debug === true ) console.log( "Switcher values: ", region, partner );
		if ( partner === null ) {
			// force partner based on region if no partner cookie is set. 2018-03-07
			switch ( region ) {
				case 'au':
				case 'nz':
				case 'as':
					dbs.set_cookie( 'partner', 'kera', 30 );
					break;
				case 'gb':
					dbs.set_cookie( 'partner', 'ker', 30 ); //hardcoded to ker now 2021-02-24 per request, was saracen
					break;
			}
		}
		window.location = window.location; // force a full refresh
	});

	// change newsletter form based on regions.
	if ( 'au' === region || 'nz' === region || 'as' === region ) {
		jQuery( '#newsletter_link' ).attr( 'href', '/equinews/kera-equinews-subscribe/' );
	} else if ( 'gb' === region ) {
		jQuery( '#newsletter_link' ).attr( 'href', '/equinews/equinews-presented-saracen/' );
	}

	// This selector targets the volume selection functionality found in page-aen-volume.php
	jQuery( '#volume_selector' ).change( function() {
		var selected = jQuery( this ).val();
		if ( selected !== 'default' ) {
			var protocol = window.location.protocol;
			var domain = window.location.domain;
			var url = protocol + domain + '/library/advances-equine-nutrition/' + selected + '/';
			window.location.href = url;
		}
	} );

	/* Print Button Functionality. */
	jQuery( '#print_button' ).click( function() {
		window.print();
	} );

	// ready events here
	jQuery( function() {
		jQuery.fn.slateNav();
		jQuery('h4+h3').prev('h4').addClass('h5');
	});

	/**
	 * Set the appropriate hidden fields to tell WP how to handle the 4 searches.
	 * Warning: Some pages have 2 search forms w/same class, and
	 * each form needs a distinct Id. Needs to run before load event.
	 */
	var $form = jQuery( '.main-search' );
	$form.on( 'change', function( e ) {
		var $thisform_id = jQuery( e.target ).parents( '.main-search' ).attr( 'id' );
		// remove all ex. hidden fields first
		jQuery( '#' + $thisform_id + ' input[type="hidden"]' ).remove();
		// Make sure we have the correct form and set hidden field based on selected radio button
		var $selected = jQuery( '#' + $thisform_id + ' input[name="search-option"]:checked' ).val();
		if ( 'library' === $selected ) { // search Library content
			jQuery( '#' + $thisform_id ).append( '<input type="hidden" name="lib" value="1" />' );
		}
		if ( 'not library' === $selected ) { // search all EXCEPT Library content
			jQuery( '#' + $thisform_id ).append( '<input type="hidden" name="notlib" value="1" />' );
		}
		if ( 'published' === $selected ) { // search Published Research content
			jQuery( '#' + $thisform_id ).append( '<input type="hidden" name="post_type" value="published" />' );
		}
		// if neither of those, we then do a full site search.
	});

	// newsletter popup code
	jQuery( window ).on( 'load', function() {
		/* newsletter popup in footer.php, see library/code/partner-newsletter.php for more config 2019-01-21 */
		if ( news_popup ) { // ie on a single post equinews page
			var delayms = ( dbs.debug ) ? 1500 : 10000;
			jQuery( '#newsletterbox' ).delay( delayms ).slideDown(); // when live set to 10 sec
			jQuery( '.newsclose' ).click( function (e) {
				e.preventDefault();
				jQuery( '#newsletterbox' ).slideUp();
			}); 

			// if query str contains utm=email suppress the popup
			if ( window.location.search.match(/utm=email/) ) dbs.set_cookie( 'ker_newsletterbox', 'true', '30' );
			// if we've seen this before, kill it.
			if ( ! dbs.debug && dbs.read_cookie( 'ker_newsletterbox' ) ) jQuery( '#newsletterbox' ). remove();
			// set a cookie if we don't have one already for 30 days.
			if ( ! dbs.debug && ! dbs.read_cookie( 'ker_newsletterbox' ) ) dbs.set_cookie( 'ker_newsletterbox', 'true', '30' );
		}
	});

})();
